import { Logger, datadogLogs } from "@datadog/browser-logs";
import { appConfig } from "@shared/utils/appConfig";

interface LoggerData {
  [key: string]: unknown;
  error?: Error | unknown;
}

interface AppLogger {
  error(message: string, data?: LoggerData): void;
}

class DatadogLogger implements AppLogger {
  private logger: Logger;
  constructor() {
    this.logger = datadogLogs.createLogger("app");
  }

  error(message: string, data?: LoggerData): void {
    const { error, ...rest } = data || {};
    return this.logger.error(message, rest, toError(error));
  }
}

class DefaultLogger implements AppLogger {
  error(message: string, data?: LoggerData): void {
    const { error, ...rest } = data || {};
    return console.error(message, rest, error);
  }
}

const getLogger = () => {
  const isDev = appConfig.APP_ENV === "development";
  const isTestEnv = appConfig.NODE_ENV === "test";

  if (isTestEnv) return new DefaultLogger();

  if (appConfig.DATADOG_CLIENT_TOKEN) {
    if (isDev) console.debug("USING DATADOG LOGGER");
    return new DatadogLogger();
  }

  if (isDev) console.debug("USING DEFAULT LOGGER");
  return new DefaultLogger();
};

function toError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === "string") {
    return new Error(error);
  }

  return new Error(JSON.stringify(error));
}

export const appLogger: AppLogger = getLogger();
